const LOCALE_KEY = "locale";

export const getLocale = () => {
  return window.localStorage.getItem(LOCALE_KEY);
};

export const saveLocale = (locale) => {
  window.localStorage.setItem(LOCALE_KEY, locale);
};

export const destroyLocale = () => {
  window.localStorage.removeItem(LOCALE_KEY);
};

export default {
  getLocale,
  saveLocale,
  destroyLocale,
};
